import { MapPin } from "lucide-react";
import Horaires from "./Horaires";
import Reveal from "./Reveal";
import { DoctolibLogo } from "./DoctolibLogo";
import { SITE } from "@/constants/site";
import useI18n from "@/i18n";

export default function RendezVous() {
    const { t } = useI18n();

    return (
        <section id="rdv" className="halo grad-rose-up scroll-mt-24 overflow-hidden py-16 md:py-24" data-testid="rdv-section">
            <div className="mx-auto max-w-[1080px] px-5">
                <Reveal>
                    <p className="eyebrow">{t.rdv.eyebrow}</p>
                    <h2 className="text-3xl text-terrat md:text-4xl">{t.rdv.h2}</h2>
                    <hr className="rule-gold mt-4 w-16" />
                    <p className="mt-4 max-w-[60ch] text-ink2">{t.rdv.lead}</p>
                </Reveal>
                <div className="mt-10 grid gap-6 md:grid-cols-2">
                    <Reveal>
                        <div className="card flex h-full flex-col p-6">
                            <h3 className="text-xl text-olivet">{t.rdv.onlineTitle}</h3>
                            <hr className="rule-gold mt-3 w-12" />
                            <div className="mt-4">
                                <DoctolibLogo height={26} />
                            </div>
                            <p className="mt-3">{t.rdv.onlineText}</p>
                            <div className="mt-auto pt-6">
                                <a
                                    href={SITE.doctolibUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="doctolib-button"
                                    className="btn btn-primary w-full md:w-auto"
                                >
                                    {t.common.rdvOn}
                                    <DoctolibLogo height={15} color="#FFFFFF" />
                                </a>
                            </div>
                        </div>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <div className="card flex h-full flex-col p-6">
                            <h3 className="text-xl text-olivet">{t.rdv.addressTitle}</h3>
                            <hr className="rule-gold mt-3 w-12" />
                            <p className="mt-4" data-testid="clinic-address-text">
                                {SITE.address}
                            </p>
                            <div className="mt-4 text-sm">
                                <Horaires compact />
                            </div>
                            <div className="mt-auto pt-6">
                                <a
                                    href={SITE.mapsUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="maps-button"
                                    className="btn btn-primary w-full md:w-auto"
                                >
                                    <MapPin size={17} aria-hidden="true" />
                                    {t.common.viewMaps}
                                </a>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
